<template>
  <BlockRepeater
    v-slot="slotProps"
    class="QuotationApproval"
    title=""
    label="Voeg een inkoop goedkeuring toe"
    :path="path"
    :values="values"
    :disabled="disabled"
    :deleted="evaluateDeletedState"
  >
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :disabled="disabled"
      :path="`${path}.${slotProps.id}`"
      :viewer="viewer"
    />
  </BlockRepeater>
</template>

<script>
import BlockRepeater from '@/components/form/BlockRepeater'
import FieldSet from '@/components/form/FieldSet'

export default {
  name: 'QuotationApproval',
  components: { BlockRepeater, FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'Party',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'PartyName': {
          'type': 'string',
          'title': 'Leverancier',
          'readonly': true,
        },
        'QuotationDescription': {
          'type': 'string',
          'title': 'Beschrijving van de werkzaamheden in de aangevraagde offerte',
          'readonly': true,
        },
        'ApprovedDate': {
          'type': 'string',
          'format': 'date',
          'title': 'Datum dat de offerte is goedgekeurd',
        },
        'deleted_at': {
          type: 'hidden',
        },
      },
      layout: [{
        'columns': '1fr 1fr',
        'fields': ['PartyName', 'ApprovedDate'],
      }, {
        'columns': '1fr 0px',
        'fields': ['QuotationDescription', 'deleted_at'],
      }],
    }
  },
  methods: {
    evaluateDeletedState({ index }) {
      return !! (
        this.values[this.path] && this.values[this.path][index] && this.values[this.path][index].deleted_at
      )
    },
  },
}
</script>
